import type { Platform } from '@/types';
import { cn } from '@/utils/cn';

interface PlatformIconProps {
  platform: Platform;
  className?: string;
}

/** Instagram brand mark (currentColor). */
export function PlatformIcon({ className }: PlatformIconProps) {
  const cls = cn('h-5 w-5', className);

  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className={cls} aria-hidden>
      <rect x="2" y="2" width="20" height="20" rx="5" />
      <circle cx="12" cy="12" r="4.5" />
      <circle cx="17.3" cy="6.7" r="1" fill="currentColor" stroke="none" />
    </svg>
  );
}
